var WATCH_FILE_KEY = "__oneWatchFile";
function watchFile(path) {
  if (typeof window !== "undefined") return;
  var impl = globalThis[WATCH_FILE_KEY];
  if (impl) {
    impl(path);
  }
}
function _registerWatchFileImpl(impl) {
  globalThis[WATCH_FILE_KEY] = impl;
}
export {
  _registerWatchFileImpl,
  watchFile
};
//# sourceMappingURL=watchFile.js.map
